// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4804":"640d5baf","7604":"4194a957"}[chunkId] + ".chunk.css";
};